(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _quantity = _interopRequireDefault(require("./modules/quantity.js"));
var _menu = _interopRequireDefault(require("./modules/menu.js"));
var _previewImage = _interopRequireDefault(require("./modules/preview-image.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Import JS classes

// Initiate JS classes
var mnu = new _menu["default"]();
var qnt = new _quantity["default"]();
var prview = new _previewImage["default"]();

},{"./modules/menu.js":2,"./modules/preview-image.js":3,"./modules/quantity.js":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var menu = /*#__PURE__*/function () {
  function menu() {
    _classCallCheck(this, menu);
    this.events();
  }
  _createClass(menu, [{
    key: "events",
    value: function events() {
      var _this = this;
      var mob_button = document.querySelector(".mobile-button");
      var dropdowns = document.querySelectorAll("#menu-product-categorieen-1 li");
      var search = document.querySelector(".search-button");
      dropdowns.forEach(function (element) {
        element.addEventListener("click", _this.showDropdown);
      });
      mob_button.addEventListener("click", this.toggleMenu);
      search.addEventListener("click", this.toggleSearch);
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu(e) {
      var container = document.querySelector(".mobile-menu-container");
      if (!container.classList.contains("open")) {
        container.classList.add("open");
        document.body.style.overflow = "hidden";
      } else {
        container.classList.remove("open");
        document.body.style.overflow = "";
      }
    }
  }, {
    key: "showDropdown",
    value: function showDropdown(event) {
      var button = event.target;
      var submenu = button.querySelector(".sub-menu");
      if (!submenu) {
        return;
      }
      if (event.target !== this) {
        return;
      }
      if (!submenu.classList.contains("displayed")) {
        submenu.classList.add("displayed");
        submenu.style.display = "block";
        button.classList.add("minus");
      } else if (submenu.classList.contains("displayed")) {
        submenu.classList.remove("displayed");
        button.classList.remove("minus");
        submenu.style.display = "none";
      }
    }
  }, {
    key: "toggleSearch",
    value: function toggleSearch(e) {
      e.preventDefault();
      var searchForm = document.querySelector(".header .search");
      var button = e.target;
      if (!button.classList.contains("clicked")) {
        searchForm.style.opacity = "1";
        searchForm.style.pointerEvents = "all";
        button.classList.add("clicked");
        document.body.style.overflow = "hidden";
      } else {
        searchForm.style.opacity = "0";
        searchForm.style.pointerEvents = "none";
        button.classList.remove("clicked");
        document.body.style.overflow = "";
      }
    }
  }]);
  return menu;
}();
var _default = menu;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PreviewImage = /*#__PURE__*/function () {
  function PreviewImage() {
    _classCallCheck(this, PreviewImage);
    this.events();
  }
  _createClass(PreviewImage, [{
    key: "events",
    value: function events() {
      var _this = this;
      if (document.body.classList.contains("single-product")) {
        var gallery = document.querySelectorAll(".gallery div");
        console.log(gallery);
        gallery.forEach(function (element) {
          element.addEventListener("click", _this.previewImage);
        });
      }
    }
  }, {
    key: "previewImage",
    value: function previewImage(e) {
      var previewBox = document.querySelector(".preview-image img");
      var box = e.target;
      if (box.hasChildNodes()) {
        var image = box.querySelector("img").src;
        previewBox.src = image;
      } else {
        previewBox.src = box.src;
      }
    }
  }]);
  return PreviewImage;
}();
var _default = PreviewImage;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var quantity = /*#__PURE__*/function () {
  function quantity() {
    _classCallCheck(this, quantity);
    if (document.body.classList.contains("single-product")) {
      this.events();
    }
  }
  _createClass(quantity, [{
    key: "events",
    value: function events() {
      var up = document.getElementById("up");
      var down = document.getElementById("down");
      if (document.body.classList.contains("single-product")) {
        down.addEventListener("click", this.quantDecrease);
        up.addEventListener("click", this.quantInrease);
      }
    }
  }, {
    key: "quantInrease",
    value: function quantInrease(event) {
      event.preventDefault();
      var input = document.querySelector(".quant");
      input.stepUp();
    }
  }, {
    key: "quantDecrease",
    value: function quantDecrease(event) {
      event.preventDefault();
      var input = document.querySelector(".quant");
      if (input.value > 0) {
        input.stepDown();
      }
    }
  }]);
  return quantity;
}();
var _default = quantity;
exports["default"] = _default;

},{}]},{},[1]);
